var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from '../Button';
import Link from '../Link';
import styled from 'styled-components';
import t from '../../lib/translate';
var StyledFormActions = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding-top: 4rem;\n  padding-bottom: 4rem;\n  button{\n    margin-right: 2rem;\n  }\n"], ["\n  padding-top: 4rem;\n  padding-bottom: 4rem;\n  button{\n    margin-right: 2rem;\n  }\n"])));
var FormActions = function (_a) {
    var submitText = _a.submitText, cancelLink = _a.cancelLink, deleteText = _a.deleteText, onDelete = _a.onDelete;
    return _jsxs(StyledFormActions, { children: [_jsx(Button, { text: submitText, submit: true }), deleteText &&
                _jsx(Button, { text: deleteText, onClick: onDelete, color: "#c92e2e" }), _jsx(Link, { to: cancelLink, text: t('general.cancel') })] });
};
export default FormActions;
var templateObject_1;
